export default __webpack_public_path__ + "static/media/b21-materials.6821ec96.png";